module.exports = __webpack_public_path__ + "5adf2cf5dfcf04abc29ce184531f96e6.MP3";